import React from "react";
import { CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CRow, CCol, CFormInput, CFormLabel,
   CFormCheck, CListGroup, CListGroupItem, CBadge, CButton, CSpinner,
    CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell,CFormSelect } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilSave, cilTrash, cilPlus } from "@coreui/icons";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";

const CameraSettings = ({
  camera, settings, handleSettingsChange, handleSaveSettings, t, i18n,
  overrides, loadingOverrides, newOverride, setNewOverride, handleAddOverride, handleDeleteOverride,
  shifts, newShift, setNewShift, handleAddShift, handleDeleteShift,
  breaks, newBreak, setNewBreak, handleAddBreak, handleDeleteBreak
}) => {
  return (
    <CAccordion className="mb-4 mt-3">
      <CAccordionItem itemKey={1}>
        <CAccordionHeader className="clickable-header">{t("camera.settings_analytics")}</CAccordionHeader>
        <CAccordionBody>
          <CRow>
            <h6 className="mb-3 text-primary">График работы</h6>
            <CCol xs={12}>
              <CFormCheck
                id="has_multiple_shifts"
                name="has_multiple_shifts"
                label="Несколько смен в сутках"
                checked={settings.has_multiple_shifts}
                onChange={handleSettingsChange}
                className="mb-3 fw-bold"
              />
            </CCol>

            {settings.has_multiple_shifts ? (
              <CCol xs={12} className="mb-4 bg-light p-2 rounded border">
                <div style={{ maxHeight: '150px', overflowY: 'auto' }} className="mb-2">
                  <CTable small hover responsive>
                    <CTableHead><CTableRow><CTableHeaderCell>Название</CTableHeaderCell><CTableHeaderCell>Начало</CTableHeaderCell><CTableHeaderCell>Конец</CTableHeaderCell><CTableHeaderCell></CTableHeaderCell></CTableRow></CTableHead>
                    <CTableBody>
                      {shifts.map(s => (
                        <CTableRow key={s.id}>
                          <CTableDataCell>{s.name}</CTableDataCell>
                          <CTableDataCell>{s.start_time.substring(0, 5)}</CTableDataCell>
                          <CTableDataCell>{s.end_time.substring(0, 5)}</CTableDataCell>
                          <CTableDataCell className="text-end"><CButton size="sm" color="danger" variant="ghost" onClick={() => handleDeleteShift(s.id)}><CIcon icon={cilTrash} /></CButton></CTableDataCell>
                        </CTableRow>
                      ))}
                    </CTableBody>
                  </CTable>
                </div>
                <CRow className="g-2 align-items-end">
                  <CCol xs={4}><CFormLabel className="small">Смена</CFormLabel><CFormInput size="sm" type="text" value={newShift.name} onChange={e => setNewShift(p => ({ ...p, name: e.target.value }))} /></CCol>
                  <CCol xs={3}><CFormLabel className="small">Старт</CFormLabel><CFormInput size="sm" type="time" value={newShift.start_time} onChange={e => setNewShift(p => ({ ...p, start_time: e.target.value }))} /></CCol>
                  <CCol xs={3}><CFormLabel className="small">Конец</CFormLabel><CFormInput size="sm" type="time" value={newShift.end_time} onChange={e => setNewShift(p => ({ ...p, end_time: e.target.value }))} /></CCol>
                  <CCol xs={2}><CButton color="primary" size="sm" className="w-100" onClick={handleAddShift}><CIcon icon={cilPlus} /></CButton></CCol>
                </CRow>
              </CCol>
            ) : (
              <>
                <CCol xs={6}><CFormInput type="time" label={t("camera.shift_start")} name="work_start_time" value={settings.work_start_time} onChange={handleSettingsChange} /></CCol>
                <CCol xs={6}><CFormInput type="time" label={t("camera.shift_end")} name="work_end_time" value={settings.work_end_time} onChange={handleSettingsChange} /></CCol>
              </>
            )}

            <CCol xs={12} className="mt-3">
              <CFormLabel>{t("camera.workdays")}</CFormLabel>
              <div className="d-flex flex-wrap gap-3">
                {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map((day) => (
                  <CFormCheck key={day} inline id={`wd-${day}`} label={day.charAt(0).toUpperCase() + day.slice(1, 3)} name={`workday_${day}`} checked={settings[`workday_${day}`]} onChange={handleSettingsChange} />
                ))}
              </div>
            </CCol>

            <CCol xs={12} className="mt-4 border-top pt-3">
              <h6 className="mb-3 text-primary">Перерывы (Обед, пересменки)</h6>
              <div style={{ maxHeight: '150px', overflowY: 'auto' }} className="mb-3">
                <CTable small hover>
                  <CTableHead><CTableRow><CTableHeaderCell>Начало</CTableHeaderCell><CTableHeaderCell>Конец</CTableHeaderCell><CTableHeaderCell>Описание</CTableHeaderCell><CTableHeaderCell></CTableHeaderCell></CTableRow></CTableHead>
                  <CTableBody>
                    {breaks.map(b => (
                      <CTableRow key={b.id}>
                        <CTableDataCell>{b.start_time.substring(0, 5)}</CTableDataCell>
                        <CTableDataCell>{b.end_time.substring(0, 5)}</CTableDataCell>
                        <CTableDataCell>{b.description}</CTableDataCell>
                        <CTableDataCell className="text-end"><CButton size="sm" color="danger" variant="ghost" onClick={() => handleDeleteBreak(b.id)}><CIcon icon={cilTrash} /></CButton></CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </div>
              <CRow className="g-2 mb-4 align-items-end">
                <CCol xs={3}><CFormLabel className="small">Старт</CFormLabel><CFormInput size="sm" type="time" value={newBreak.start_time} onChange={e => setNewBreak(p => ({ ...p, start_time: e.target.value }))} /></CCol>
                <CCol xs={3}><CFormLabel className="small">Конец</CFormLabel><CFormInput size="sm" type="time" value={newBreak.end_time} onChange={e => setNewBreak(p => ({ ...p, end_time: e.target.value }))} /></CCol>
                <CCol xs={4}><CFormLabel className="small">Описание</CFormLabel><CFormInput size="sm" type="text" value={newBreak.description} onChange={e => setNewBreak(p => ({ ...p, description: e.target.value }))} /></CCol>
                <CCol xs={2}><CButton color="success" variant="outline" size="sm" className="w-100" onClick={handleAddBreak}><CIcon icon={cilPlus} /></CButton></CCol>
              </CRow>
            </CCol>

            <CCol xs={12} className="mt-4 border-top pt-3">
              <CFormLabel className="fw-bold">{t("camera.exceptions")}</CFormLabel>
              {loadingOverrides ? <CSpinner size="sm" /> : (
                <>
                  <CListGroup style={{ maxHeight: "200px", overflowY: "auto" }} className="mb-3">
                    {overrides.length > 0 ? overrides.map((ov) => (
                      <CListGroupItem key={ov.id} className="d-flex justify-content-between align-items-center">
                        <div><strong>{dayjs(ov.date).format("DD.MM.YYYY")}</strong> - <CBadge color={ov.is_working ? "success" : "secondary"}>{ov.is_working ? t("camera.is_working_true") : t("camera.is_working_false")}</CBadge><div className="small text-muted">{ov.description}</div></div>
                        <CButton color="light" size="sm" onClick={() => handleDeleteOverride(ov.id)}><CIcon icon={cilTrash} /></CButton>
                      </CListGroupItem>
                    )) : <CListGroupItem className="text-center text-muted">Исключений нет</CListGroupItem>}
                  </CListGroup>
                  <CRow className="g-2 align-items-end">
                    <CCol xs={4}><CFormLabel className="small">{t("common.date_start")}</CFormLabel><DatePicker selected={newOverride.date} onChange={(date) => setNewOverride(p => ({ ...p, date }))} className="form-control form-control-sm" dateFormat="dd.MM.yyyy" locale={i18n.language === "ru" ? "ru" : "en"} /></CCol>
                    <CCol xs={5}><CFormInput size="sm" label={<span className="small">{t("common.description")}</span>} value={newOverride.description} onChange={(e) => setNewOverride(p => ({ ...p, description: e.target.value }))} /></CCol>
                    <CCol xs={3} className="d-flex flex-column align-items-start"><CFormCheck className="small" label={t("camera.is_working")} checked={newOverride.is_working} onChange={(e) => setNewOverride(p => ({ ...p, is_working: e.target.checked }))} /><CButton color="primary" size="sm" className="mt-1" onClick={handleAddOverride}><CIcon icon={cilPlus} /> {t("common.add")}</CButton></CCol>
                  </CRow>
                </>
              )}
            </CCol>

            <CCol xs={12} className="mt-4 border-top pt-3">
              <CFormInput type="number" label={t("camera.timezone_offset")} name="timezone_offset" value={settings.timezone_offset} onChange={handleSettingsChange} helpText={t("camera.timezone_help")} />
            </CCol>
            <CCol xs={12} className="mt-4 border-top pt-3">
              <CFormSelect
                label="Режим работы аналитики"
                name="operating_mode"
                value={settings.operating_mode}
                onChange={handleSettingsChange}
                className="fw-bold"
              >
                <option value="auto_service">Автосервис (анализ техники)</option>
                <option value="personnel_control">Контроль персонала (присутствие)</option>
                <option value="cafe">Кафе (контроль персонала + очередь)</option>
                <option value="szsm">Контроль персонала (СЗСМ - станки)</option>
                <option value="manager">Кафе + Менеджер (пересечение людей)</option>
                <option value="timesheet">Табель рабочего времени (API Интеграция)</option>
              </CFormSelect>
            </CCol>

            {settings.operating_mode === "timesheet" && (
              <CCol xs={12} className="mt-3 p-3 bg-light border rounded">
                <CFormInput
                  type="number"
                  label="ID сотрудника в системе заказчика"
                  name="external_employee_id"
                  value={settings.external_employee_id || ''}
                  onChange={handleSettingsChange}
                  helpText="Укажите ID сотрудника, за которым закреплено это рабочее место (для выгрузки в табель)."
                />
              </CCol>
            )}

            <hr className="my-4" />
            {settings.operating_mode === "auto_service" && (
              <>
                <CCol xs={6}><CFormInput type="number" label={t("camera.thresh_vehicle_roi")} name="vehicle_roi_threshold" value={settings.vehicle_roi_threshold} onChange={handleSettingsChange} min="0" max="100" /></CCol>
                <CCol xs={6}><CFormInput type="number" step="0.1" label={t("camera.thresh_vehicle_occ")} name="vehicle_roi_occupancy_threshold" value={settings.vehicle_roi_occupancy_threshold} onChange={handleSettingsChange} min="0" max="100" /></CCol>
                <CCol xs={12} className="mt-3"><CFormInput type="number" label={t("camera.merge_time")} name="vehicle_log_merge_seconds" value={settings.vehicle_log_merge_seconds} onChange={handleSettingsChange} min="30" max="3600" /></CCol>
                <CCol xs={12} className="mt-3"><CFormInput type="number" label={t("camera.orb_thresh")} name="orb_similarity_threshold" value={settings.orb_similarity_threshold} onChange={handleSettingsChange} min="10" max="2000" /></CCol>
                <CCol xs={6} className="mt-3 mb-3"><CFormInput type="number" label={t("camera.thresh_vehicle_conf")} name="vehicle_confidence_threshold" value={settings.vehicle_confidence_threshold} onChange={handleSettingsChange} min="0.5" max="90" step="0.1" /></CCol>
                <hr className="my-4" />
              </>
            )}
            <CCol xs={6}><CFormInput type="number" label={t("camera.thresh_person_roi")} name="person_roi_threshold" value={settings.person_roi_threshold} onChange={handleSettingsChange} min="0" max="100" /></CCol>
            <CCol xs={6}><CFormInput type="number" step="0.01" label={t("camera.thresh_person_occ")} name="person_roi_occupancy_threshold" value={settings.person_roi_occupancy_threshold} onChange={handleSettingsChange} min="0" max="100" /></CCol>
            <CCol xs={6} className="mt-3 mb-3"><CFormInput type="number" label={t("camera.thresh_person_conf")} name="person_confidence_threshold" value={settings.person_confidence_threshold} onChange={handleSettingsChange} min="0.5" max="90" step="0.1" /></CCol>

            <CCol xs={12} className="mt-2 border-top pt-3"><CFormCheck id="countSquattingCheck" label={t("camera.count_squatting")} name="count_squatting_as_sitting" checked={settings.count_squatting_as_sitting} onChange={handleSettingsChange} /></CCol>

            {(!camera?.parent && !camera?.is_combined_camera) && (
              <CCol xs={12} className="mt-3 p-3 bg-light border rounded"><CFormCheck id="enableBlurCheck" label={<span className="fw-bold text-primary">{t("camera.blur_setting")}</span>} name="enable_blur" checked={settings.enable_blur} onChange={handleSettingsChange} /></CCol>
            )}
          </CRow>
          <CButton color="primary" onClick={handleSaveSettings} className="mt-4 w-100"><CIcon icon={cilSave} className="me-2" /> {t("camera.save_settings")}</CButton>
        </CAccordionBody>
      </CAccordionItem>
    </CAccordion>
  );
};
export default CameraSettings;